'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _theme = require('../theme');

var _mixins = require('../utils/mixins');

require('../utils/focus-source');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref = _react2.default.createElement('div', null);

var Button = (_dec = (0, _theme.injectSheet)(function (theme) {
  return _extends({
    button: _extends({
      extend: _mixins.isolateMixin,
      fontFamily: theme.button.fontFamily,
      fontStyle: theme.button.fontStyle,
      fontWeight: theme.button.fontWeight,
      letterSpacing: theme.button.letterSpacing,
      textTransform: theme.button.textTransform,
      textAlign: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      textDecoration: 'none !important',
      outline: 'none !important',
      position: 'relative',
      display: 'inline-block',
      border: 'none',
      userSelect: 'none',
      borderRadius: theme.button.borderRadius
    }, (0, _mixins.ifMobile)({
      fontWeight: theme.button.mobile.fontWeight,
      letterSpacing: theme.button.mobile.letterSpacing
    }), {
      '&, & *': {
        transition: 'background-color .2s, border .2s, box-shadow .2s'
      },
      '&:before, &:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        pointerEvents: 'none',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        border: '1px solid transparent',
        transition: 'all .2s',
        borderRadius: theme.button.borderRadius
      },
      '&[disabled]': { pointerEvents: 'none' },
      '&::-moz-focus-inner': {
        border: 'none !important',
        outline: 'none !important'
      }
    }),
    isRounded: {
      '&$button, &:before, &:after': {
        borderRadius: '9999px !important'
      }
    },
    isLoading: {
      pointerEvents: 'none',
      opacity: 0
    },
    loader: _extends({
      fontSize: 3
    }, (0, _mixins.ifMobile)({
      fontSize: 4
    })),
    content: _extends({
      extend: [_mixins.middleMixin, _mixins.fontSmoothingMixin],
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      position: 'relative',
      padding: '0 20px'
    }, (0, _mixins.ifMobile)({
      padding: '0 25px'
    })),
    block: {
      display: 'block',
      width: '100%'
    },
    'size-medium': _extends({
      fontSize: theme.button.sizes.medium.fontSize
    }, (0, _mixins.ifMobile)({
      fontSize: theme.button.mobile.sizes.medium.fontSize
    }), {
      '& $content': _extends({
        height: theme.button.sizes.medium.height,
        lineHeight: theme.button.sizes.medium.height + 'px'
      }, (0, _mixins.ifMobile)({
        height: theme.button.mobile.sizes.medium.height,
        lineHeight: theme.button.mobile.sizes.medium.height + 'px'
      }))
    }),
    'size-small': _extends({
      fontSize: theme.button.sizes.small.fontSize
    }, (0, _mixins.ifMobile)({
      fontSize: theme.button.mobile.sizes.small.fontSize
    }), {
      '& $content': _extends({
        height: theme.button.sizes.small.height,
        lineHeight: theme.button.sizes.small.height + 'px'
      }, (0, _mixins.ifMobile)({
        height: theme.button.mobile.sizes.small.height,
        lineHeight: theme.button.mobile.sizes.small.height + 'px'
      }))
    }),
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      opacity: 0,
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    },
    icon: {
      display: 'inline-block',
      marginTop: -2,
      transition: 'fill .2s'
    },
    'iconPosition-right': {
      '& $icon': _extends({
        marginLeft: 5
      }, (0, _mixins.ifMobile)({
        marginLeft: 10
      }))
    },
    'iconPosition-left': {
      '& $icon': _extends({
        marginRight: 5
      }, (0, _mixins.ifMobile)({
        marginRight: 10
      }))
    }
  }, ['primary', 'secondary', 'outline', 'flat', 'danger'].reduce(function (result, type) {
    var conf = theme.button.types[type];
    var offset = conf.outlineOffset || 0;

    var setThemeForSelector = function setThemeForSelector(colors, outlineOffset) {
      return {
        background: colors.background,
        '&, & *': {
          color: colors.text
        },
        '&:before': _extends({}, colors.border && {
          borderColor: colors.border
        }),
        '&:after': _extends({}, colors.outline && {
          left: -outlineOffset,
          right: -outlineOffset,
          top: -outlineOffset,
          bottom: -outlineOffset,
          borderColor: colors.outline,
          borderRadius: theme.button.borderRadius + outlineOffset / 1.5
        }),
        '& $icon': {
          fill: colors.icon
        }
      };
    };

    return _extends({}, result, _defineProperty({}, 'type-' + type, _extends({
      '&:active:active': setThemeForSelector(conf.colors.active, offset),
      '&:hover': setThemeForSelector(conf.colors.hover, offset),
      '&[disabled]': setThemeForSelector(conf.colors.disabled, offset)
    }, (0, _mixins.focusSourceMixin)('other', '&:focus', setThemeForSelector(conf.colors.focus, offset)), setThemeForSelector(conf.colors.default, offset), {
      '& $loader': {
        color: conf.colors.default.loader
      }
    })));
  }, {}));
}, { name: 'Button' }), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'renderIcon',
    value: function renderIcon(icon) {
      if (icon) {
        var _props = this.props,
            theme = _props.theme,
            size = _props.size,
            classes = _props.classes;

        var iconProps = {
          size: theme.button.sizes[size].icon,
          color: null
        };
        var initialProps = icon.props || {};
        var className = (0, _classnames3.default)(initialProps.className, classes.icon);
        var resultProps = _extends({}, iconProps, initialProps, { className: className });
        return (0, _react.cloneElement)(icon, resultProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          icon = _props2.icon,
          children = _props2.children,
          size = _props2.size,
          type = _props2.type,
          href = _props2.href,
          container = _props2.container,
          buttonType = _props2.buttonType,
          disabled = _props2.disabled,
          loading = _props2.loading,
          block = _props2.block,
          className = _props2.className,
          overlay = _props2.overlay,
          width = _props2.width,
          iconPosition = _props2.iconPosition,
          rounded = _props2.rounded,
          _props2$style = _props2.style,
          style = _props2$style === undefined ? {} : _props2$style,
          classes = _props2.classes,
          theme = _props2.theme,
          other = _objectWithoutProperties(_props2, ['icon', 'children', 'size', 'type', 'href', 'container', 'buttonType', 'disabled', 'loading', 'block', 'className', 'overlay', 'width', 'iconPosition', 'rounded', 'style', 'classes', 'theme']);

      var iconLeft = iconPosition === 'left';
      var iconEl = this.renderIcon(icon);

      var resultStyle = _extends({
        width: width
      }, style);
      var resultClassName = (0, _classnames3.default)(classes.button, rounded && classes.isRounded, classes['type-' + type], classes['size-' + size], classes['iconPosition-' + iconPosition], className, _defineProperty({}, classes.block, block));

      var resultChildren = _react2.default.createElement(
        'span',
        {
          className: (0, _classnames3.default)(classes.content, loading && classes.isLoading) },
        iconLeft && iconEl,
        children,
        !iconLeft && iconEl,
        overlay && (0, _react.cloneElement)(overlay, { className: classes.overlay })
      );

      var resultProps = _extends({}, other, {
        style: resultStyle,
        className: resultClassName,
        disabled: disabled ? 'disabled' : null
      });

      var resultContainer = (0, _react.isValidElement)(container) ? container : href ? _react2.default.createElement('a', { href: href }) : overlay ? _ref : _react2.default.createElement('button', { type: buttonType });

      return (0, _react.cloneElement)(resultContainer, resultProps, resultChildren, loading && _react2.default.createElement(_Spinner2.default, { className: classes.loader, color: null }));
    }
  }]);

  return Button;
}(_react.PureComponent), _class2.defaultProps = {
  type: 'primary',
  size: 'medium',
  buttonType: 'button',
  iconPosition: 'left',
  block: false
}, _temp)) || _class);
exports.default = Button;
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Тип стиля кнопки
   */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'outline', 'flat', 'danger']),
  /**
   * Если указан href, то кнопка будет ссылкой
   */
  href: _propTypes2.default.string,
  /**
   * Атрибут target для ссылки, если указан атрибут href
   */
  target: _propTypes2.default.string,
  /**
   * Css-класс
   */
  className: _propTypes2.default.string,
  /**
   * Inline-стили
   */
  style: _propTypes2.default.object,
  /**
   * Контент для кнопки
   */
  children: _propTypes2.default.node,
  /**
   * Иконка для кнопки
   */
  icon: _propTypes2.default.node,
  /**
   * Позиция иконки: слева/справа
   */
  iconPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Размер кнопки
   */
  size: _propTypes2.default.oneOf(['small', 'medium']),
  /**
   * Обработчик клика
   */
  onClick: _propTypes2.default.func,
  /**
   * Элемент, который содержит контент, например `<Link />`
   * в случае с `react-router`
   */
  container: _propTypes2.default.element,
  /**
   * Элемент, который прозрачно накладывается на кнопку (Например `<input type="file" />`)
   */
  overlay: _propTypes2.default.element,
  /**
   * Отключаем кнопку/ссылку
   */
  disabled: _propTypes2.default.bool,
  /**
   * Отображать кнопку как блочный элемент
   */
  block: _propTypes2.default.bool,
  /**
   * Тип кнопки
   */
  buttonType: _propTypes2.default.string,
  /**
   * Ширина кнопки
   */
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * Показывать индикатор загрузки
   */
  loading: _propTypes2.default.bool,
  /**
   * Закругленная кнопка
   */
  rounded: _propTypes2.default.bool
} : {};